import { render } from "./slidemagazin-19.vue?vue&type=template&id=e8760250&scoped=true"
import script from "./slidemagazin-19.vue?vue&type=script&lang=js"
export * from "./slidemagazin-19.vue?vue&type=script&lang=js"

import "./slidemagazin-19.vue?vue&type=style&index=0&id=e8760250&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8760250"]])

export default __exports__